/* FreshBox mega-nav — image+caption swap per subcategory, reset to golden hero on leave.
   Mirrors the prototype behaviour. Pure progressive enhancement (CSS handles reveal). */
(function () {
  document.querySelectorAll('.fbnav__item').forEach(function (item) {
    var prev = item.querySelector('[data-prev]');
    if (!prev) return;
    var imgs = prev.querySelectorAll('.fbprev__img');
    var cap = prev.querySelector('[data-cap]');
    var k = cap ? cap.querySelector('.kick') : null;
    var t = cap ? cap.querySelector('.t') : null;
    var d = cap ? cap.querySelector('.d') : null;

    // snapshot the default (golden hero) state once
    var def = prev.querySelector('.fbprev__img.is-active') || imgs[0];
    var dk = k ? k.innerHTML : '';
    var dt = t ? t.innerHTML : '';
    var dd = d ? d.innerHTML : '';

    function reset() {
      imgs.forEach(function (im) { im.classList.toggle('is-active', im === def); });
      if (k) k.innerHTML = dk;
      if (t) t.innerHTML = dt;
      if (d) d.innerHTML = dd;
    }

    item.querySelectorAll('.fbsub a').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        var key = link.getAttribute('data-img');
        imgs.forEach(function (im) { im.classList.toggle('is-active', im.hasAttribute('data-img-' + key)); });
        if (k) k.textContent = link.getAttribute('data-kick') || '';
        if (t) t.textContent = link.getAttribute('data-title') || '';
        if (d) d.textContent = link.getAttribute('data-desc') || '';
      });
    });

    item.addEventListener('mouseleave', reset);
  });
})();
